import { useEffect, useState } from "react";

// Tarefa 9 (specs/front_planning_tools/plan.md, FR-019): tempo decorrido, ao vivo
// enquanto uma etapa está em andamento, congelado quando ela termina.

const TOTAL_TICK_MS = 1000;
const STEP_TICK_MS = 100;

export function formatDuration(totalSeconds) {
  const seconds = Math.max(0, Math.floor(totalSeconds));
  if (totalSeconds > 0 && totalSeconds < 1) {
    return `${totalSeconds.toFixed(1)}s`;
  }
  if (seconds < 60) {
    return `${seconds}s`;
  }
  const minutes = Math.floor(seconds / 60);
  const remainder = seconds % 60;
  return `${minutes}m ${remainder}s`;
}

export function shouldShowDuration(totalSeconds) {
  return typeof totalSeconds === "number" && totalSeconds >= 0.1;
}

// Duração de uma etapa/tool individual: décimo de segundo abaixo de 1 minuto,
// porque tool que roda em 400ms aparecia como "0s". Acima disso o décimo não
// acrescenta nada e o formato volta a ser o mesmo do tempo total.
export function formatStepDuration(totalSeconds) {
  const seconds = Math.max(0, Math.round(totalSeconds * 10) / 10);
  if (seconds < 60) {
    return `${seconds.toFixed(1)}s`;
  }
  return formatDuration(seconds);
}

export function useElapsedSeconds(
  startedAt,
  isActive,
  frozenMs,
  tickMs = TOTAL_TICK_MS,
) {
  const [, forceTick] = useState(0);

  useEffect(() => {
    if (!isActive || startedAt == null) {
      return undefined;
    }
    const id = setInterval(() => forceTick((n) => n + 1), tickMs);
    return () => clearInterval(id);
  }, [isActive, startedAt, tickMs]);

  if (!isActive && typeof frozenMs === "number") {
    return frozenMs / 1000;
  }
  if (startedAt == null) {
    return null;
  }
  // Sem arredondar: quem formata é que decide a precisão (segundo cheio no total,
  // décimo na linha de etapa/tool).
  return (Date.now() - startedAt) / 1000;
}

// Tempo de uma linha de etapa/tool - conta em décimos, então o tick é mais fino.
export function useStepElapsedSeconds(startedAt, isActive, frozenMs) {
  return useElapsedSeconds(startedAt, isActive, frozenMs, STEP_TICK_MS);
}

export function frozenStepDurationMs(anterior, status, startedAt) {
  if (anterior && typeof anterior.durationMs === "number") {
    return anterior.durationMs;
  }
  if (status === "in_progress" || startedAt == null) {
    return undefined;
  }
  return Date.now() - startedAt;
}

export function frozenToolDurationMs(evento, anterior, startedAt) {
  if (typeof evento.ms === "number") {
    return evento.ms;
  }
  const status = evento.status === "running" ? "in_progress" : "completed";
  return frozenStepDurationMs(anterior, status, startedAt);
}
